import { useEffect } from 'react';
import { onIdTokenChanged, signOut, getIdToken } from 'firebase/auth';
import { auth } from '../config/firebase';
import { getLoginRoute, isInIframe } from '../utils/navigationHelper';

const useSessionManager = () => {
  useEffect(() => {
    const hoy = new Date().toDateString();
    const fechaGuardada = localStorage.getItem('fecha_sesion');

    if (fechaGuardada && fechaGuardada !== hoy) {
      signOut(auth).then(() => {
        localStorage.removeItem('fecha_sesion');
        localStorage.removeItem('usuario');
        localStorage.removeItem('token');
        // Limpiar la ruta guardada solo si está en iframe
        if (isInIframe()) {
          localStorage.setItem('ovi_iframe_route', 'https://minymol.com/loginovi');
        }
        // Redirigir a la ruta de login correcta
        window.location.href = getLoginRoute();
      });
    } else {
      localStorage.setItem('fecha_sesion', hoy);
    }

    // 🔄 Se activa siempre que el token cambie
    const unsubscribe = onIdTokenChanged(auth, (user) => {
      if (user) {
        const fechaSesion = localStorage.getItem('fecha_sesion');
        const hoy = new Date().toDateString();

        if (fechaSesion !== hoy) {
          signOut(auth).then(() => {
            localStorage.removeItem('fecha_sesion');
            localStorage.removeItem('usuario');
            localStorage.removeItem('token');
            // Limpiar la ruta guardada solo si está en iframe
            if (isInIframe()) {
              localStorage.setItem('ovi_iframe_route', 'https://minymol.com/loginovi');
            }
            // Redirigir a la ruta de login correcta
            window.location.href = getLoginRoute();
          });
        }
      }
    });

    // 🔁 Forzar renovación cada 50 minutos
    const intervalId = setInterval(async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          await getIdToken(user, true);
        } catch (err) {
        }
      } else {
      }
    }, 1000 * 60 * 50); // 50 minutos

    return () => {
      unsubscribe();
      clearInterval(intervalId);
    };
  }, []);
};

export default useSessionManager;
